import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoginPage } from '../pages/Auth/LoginPage'
import { SignupPage } from '../pages/Auth/SignupPage'
import { PricingPage } from '../pages/Pricing/PricingPage'
import { DocumentsPage } from '../pages/Documents/DocumentsPage'
import { EditorLayout } from '../layouts/EditorLayout'
import { DocumentEditor } from '../pages/Editor/DocumentEditor'
import { SettingsPage } from '../pages/Settings/SettingsPage'
import { InAppLayout } from '../layouts/InAppLayout'
import { DocumentPrinting } from '../pages/Printing/DocumentPrinting'
import { PrivacyPolicy } from '../pages/PrivacyPolicy'
import { TermsOfService } from '../pages/TermsOfService'
import { PurchaseOrderPage } from '../pages/Printing/PurchaseOrder/PurchaseOrderPage'
import { NotFoundPage } from '../pages/NotFound/NotFound'
import { SuppliersPage } from '../pages/Suppliers/SuppliersPage'
import { SuppliersEditPage } from '../pages/Suppliers/SuppliersEditPage'
import { AcceptInvitationPage } from '../pages/Auth/InvitePage'
import { ProductLibraryPage } from '../pages/ProductLibrary/ProductLibraryPage'
import { UpgradePage } from '../pages/Pricing/UpgradePage'

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SignupPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      {/* <Route
        path="/internal/print/document/:id"
        element={<DocumentPrinting />}
      /> */}
      <Route path="/internal/print/document" element={<DocumentPrinting />} />
      <Route
        path="/internal/print/purchase-order"
        element={<PurchaseOrderPage />}
      />
      <Route path="/app" element={<InAppLayout />}>
        {/* <Route index element={<DocumentsPage />} /> */}
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="suppliers" element={<SuppliersPage />} />
        <Route path="suppliers/:id" element={<SuppliersEditPage />} />
        <Route path="product-library" element={<ProductLibraryPage />} />
        <Route path="settings/*" element={<SettingsPage />} />
        <Route path="upgrade" element={<UpgradePage />} />
        <Route path="editor" element={<EditorLayout />}>
          <Route index element={<DocumentEditor />} />
          <Route path=":id" element={<DocumentEditor />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
